export enum GameRoundCount {
  'ctm' = 9,
}
